module.exports = __webpack_public_path__ + "static/media/19.831da3e3.png";